// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Question_inputWrapper__6u-0Y","answersSpace":"Question_answersSpace__ygi4o"};